import Helper from '@lovata/popup-helper';
import ShopaholicCartPosition from '@lovata/shopaholic-cart/shopaholic-cart-position';
import ButtonBlock from '../../product-buy/button-block';

export default new class cartMini {
  constructor() {
    this.panelSelector = 'cart-info__panel';
    this.panelOpenSelector = 'cart-info__panel_visible';
    this.drawerBtnSelector = 'js-cart-mini';
    this.drawerParentSelector = 'header';
    this.drawerDisableSelector = 'cart-info_empty';
    this.drawerCloseSelector = 'cart-mini-panel__close';

    this.preLoaderSelector = 'cart-mini-panel__preloader';

    this.panelPartialSelector = 'product/cart/cart-mini/cart-mini-panel/cart-mini-panel-ajax';
    this.listWrapperSelector = '_shopaholic-cart-list';

    this.countPartialSelector = 'product/cart/cart-count-ajax';
    this.countSelector = '.cart-count';

    this.pageIdAttr = 'data-page-id';
    this.cartPageId = 'checkout';

    this.buttonsClass = '.button-buy.is__mobile';
    this.offerIdAttr = 'offer-id';

    this.removePositionButton = '._shopaholic-cart-remove, ._shopaholic-cart-restore';

    this.disableMiniCart();
    this.updateCount();
    this.handler();
  }

  disableMiniCart() {
    const isCartPage = document.body.getAttribute(this.pageIdAttr) === this.cartPageId;

    if (!isCartPage) return;

    document.querySelector(`.${this.drawerBtnSelector}`).classList.add(this.drawerDisableSelector);
  }

  handler() {
    $(document).on('click', `.${this.drawerBtnSelector}`, ({ currentTarget }) => {
      const isDisable = $(currentTarget).hasClass(this.drawerDisableSelector);

      if (isDisable) return;

      const panel = $(currentTarget).parents('body').find(`.${this.panelSelector}`);

      const focusTarget = !panel.hasClass(this.drawerOpenBtnSelector)
        ? document.querySelector(`.${this.drawerCloseSelector}`)
        : document.querySelector(`.${this.drawerOpenBtnSelector}`);

      const isOpen = panel.hasClass(this.panelOpenSelector);
      // const closeBtnNode = document.querySelector(`.${this.drawerCloseSelector}`);
      Helper.setBodyScrollState(isOpen);
      Helper.overlayController(!isOpen);

      // eslint-disable-next-line no-console
      console.log(focusTarget);

      // eslint-disable-next-line no-console
      console.log(panel[0]);

      panel.toggleClass(this.panelOpenSelector);
      Helper.overlayHandler(!isOpen, focusTarget, panel[0]);

      setTimeout(() => {
        Helper.focusTrapManager(!isOpen, panel[0]);
      }, 300);

      this.updateButtons(isOpen);
    });

    $(document).on('click', `${this.removePositionButton}`, (e) => {
      const obShopaholicCartPosition = new ShopaholicCartPosition(e.target);
      setTimeout(() => {
        obShopaholicCartPosition.getData();
      }, 300);
    });
  }

  loadCart() {
    $.request('onAjax', {
      update: {
        [this.panelPartialSelector]: `.${this.listWrapperSelector}`,
      },
      success: function (res) { // eslint-disable-line object-shorthand, func-names
        this.success(res);
      },
      loading: `.${this.preLoaderSelector}`,
    });
  }

  updateCount() {
    document.addEventListener('shopaholic.cart.position.extend', (e) => {
      // eslint-disable-next-line no-console
      console.log(e);
      $.request('onAjaxRequest', {
        update: {
          [this.countPartialSelector]: `${this.countSelector}`,
        },
        success: function success(response) {
          this.success(response);
        },
        loading: `.${this.preLoaderSelector}`,
      });
    });
  }

  updateButtons(isOpen) {
    if (!isOpen) return;

    const inCartButtons = document.querySelectorAll(`${this.buttonsClass}`);

    [...inCartButtons].forEach(el => this.handleButton(el));
  }

  handleButton(el) {
    const offsetId = $(el).data(`${this.offerIdAttr}`);
    ButtonBlock.update(offsetId);
  }
}();
